import { Injectable } from '@angular/core';
import { Api } from '../api/api';
import { Logger } from 'ionic-logging-service';
import {AddressData} from '../../interfaces/address-data';
import {ContactNumberData} from '../../interfaces/contact-number-data';

/*
  Generated class for the PhonePanelProvider provider.

  See https://angular.io/guide/dependency-injection for more info on providers
  and Angular DI.
*/
@Injectable()
export class PhonePanelProvider {

  phoneData: ContactNumberData = new ContactNumberData();
  addressData: AddressData = new AddressData();
  private logger: Logger;

  constructor(public api: Api) {

  }

  private getLogger() {
    if(this.logger) {
      return this.logger;
    }

    return this.logger = this.api.getLogger('Hausnotruf.PhonePanel');
  }

  callNumber(phoneNumber, notrufTelefonNummer) {
    return new Promise((resolve)=>{
      this.api.get('callNumber', {phoneNumber, notrufTelefonNummer}).subscribe({next:(data) => {
        this.getLogger().info('callNumber', {data, phoneNumber, notrufTelefonNummer});
        resolve({data, phoneNumber, notrufTelefonNummer});
      }, error:(err) => {
        this.getLogger().error('callNumber', 'Nummer nicht erreichbar', {err, phoneNumber, notrufTelefonNummer});
        resolve({err, phoneNumber, notrufTelefonNummer});
      }});
    });
  }
}
